import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "width", "openDrawer", "sx"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import Drawer from '@mui/material/Drawer';
export var MuiRightDrawer = function (props) {
    var children = props.children, _a = props.width, width = _a === void 0 ? '60%' : _a, open = props.openDrawer, sx = props.sx, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Drawer, _extends({
        open: open,
        transitionDuration: {
            enter: 500,
            exit: 100
        },
        anchor: "right"
    }, others, {
        PaperProps: {
            sx: _objectSpread({
                width: width,
                maxWidth: '600px',
                boxSizing: 'border-box',
                minWidth: '300px'
            }, sx)
        }
    }), open && children);
};
